import React from "react";
import DekningskartIframe from "../../components/atoms/DekningskartIframe/DekningskartIframe";
import "./Dekningskart.less";

const Dekningskart: React.FC = () => (
    <div className="retailer-dashboard-wrapper">
        <DekningskartIframe className="dekningskart-page__iframe" />
    </div>
);

export default Dekningskart;
